<template>
  <section v-if="screenContent" class="scene">
    <!-- people -->
    <WorldNpc1 v-if="screenContent.NPC1" :npcs="screenContent.NPC1" :speechbubble="screenContent.SpeechBubble" />
    <WorldNpc2 v-if="screenContent.NPC2" :npcs="screenContent.NPC2" />
    <!-- arrows -->
    <Arrow direction="left" theme="purple" @click="clickVillage" />
    <!-- world -->
    <div class="worldmap">
      <div class="worldmap__inner">
        <img alt="Frame Wood" src="@/assets/images/world/frame-wood.svg" class="frame-wood">
        <img alt="Frame Top Left" src="@/assets/images/world/frame-top-left.png" class="frame frame--topleft">
        <img alt="Frame Top Right" src="@/assets/images/world/frame-top-right.png" class="frame frame--topright">
        <div class="frame frame--top" />
        <div class="frame frame--left" />
        <div class="frame frame--right" />
        <div class="worldmap__map">
          <transition name="fade" mode="out-in">
            <div v-if="activeLocation === null" class="underlay">
              <!-- world map -->
              <picture v-if="screenContent.WorldMap">
                <img
                  class="map__canvas"
                  :alt="`${screenContent.WorldTitle} map`"
                  :src="screenContent.WorldMap"
                  :srcset="`${screenContent.WorldMap} 2600w`"
                  width="500"
                  height="365"
                  sizes="100vw"
                >
              </picture>
              <!-- tag -->
              <a
                v-for="(location, index) in screenContent.Maps"
                :key="`location-${index}`"
                class="location"
                :style="`top:${location.Top}%;left:${location.Left}%`"
                @click="setActiveMap(location)"
              >
                <picture v-if="location.MapUrl && location.Tag">
                  <img
                    class="location__tag"
                    :alt="`Tag ${index}`"
                    :src="location.Tag"
                    :srcset="`${location.Tag} 700w`"
                    sizes="300px"
                  >
                </picture>
              </a>
            </div>
            <!-- location map -->
            <div v-else class="underlay">
              <a class="worldmap__close" @click="setActiveMap(null)">
                <img alt="Close" src="@/assets/images/icons/close-white.svg" width="29" height="29">
              </a>
              <picture v-if="activeLocation.MapUrl">
                <img
                  class="map__canvas"
                  alt="Map"
                  :src="activeLocation.MapUrl"
                  :srcset="`${activeLocation.MapUrl} 2600w`"
                  width="500"
                  height="365"
                  sizes="100vw"
                >
              </picture>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <!-- scroll -->
    <transition name="fade" mode="out-in">
      <div v-if="scrollEnabled & mapModal" class="modal" :key="activeLocation">
        <div class="underlay underlay--modal" @click="setMapModal(null)" />
        <div class="scroll">
          <picture>
            <img
              class="scroll__background"
              alt="Scroll"
              src="@/assets/images/village/scroll.png"
              srcset="@/assets/images/village/scroll.png 700w"
              width="744"
              height="499"
              sizes="50vw"
            >
          </picture>
          <div class="scroll__inner">
            <a class="scroll__close pagelink" @click="setMapModal(null)">
              <img alt="Close" src="@/assets/images/icons/close.svg" width="25" height="25">
            </a>
            <div v-if="activeLocation">
              <p
                v-if="activeLocation.Title"
                v-text="activeLocation.Title"
                class="lead"
              />
              <p
                v-if="activeLocation.Description"
                v-text="activeLocation.Description"
              />
            </div>
            <div v-else>
              <p
                v-if="screenContent.WorldTitle"
                v-text="screenContent.WorldTitle"
                class="lead"
              />
              <p
                v-if="screenContent.WorldDescription"
                v-text="screenContent.WorldDescription"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- content -->
    <div class="content content--top">
      <div class="container">
        <div class="title">
          <h2 v-if="screenContent.Heading" class="mb-1">
            {{ screenContent.Heading }}
          </h2>
          <h4 v-if="screenContent.SubHeading">
            {{ screenContent.SubHeading }}
          </h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Arrow from '@/components/parts/Arrow.vue'
import WorldNpc1 from '@/components/npcs/WorldNpc1.vue'
import WorldNpc2 from '@/components/npcs/WorldNpc2.vue'

export default {
  name: 'World',

  components: {
    Arrow,
    WorldNpc1,
    WorldNpc2
  },

  data () {
    return {
      scrollEnabled: false, // display scroll descriptions ? (removed due to missing content)
      modalTimeout: null,
      activeLocation: null,
      mapModal: false
    }
  },

  computed: {
    screenContent () {
      return this.$store.getters.getContentWorld
    },
    sceneName () {
      return this.$store.getters.getSceneName
    }
  },

  beforeUnmount () {
    clearTimeout(this.modalTimeout)
    this.setMapModal(false)
  },

  mounted () {
    this.$gtm.trackEvent({
      'event': 'View Landing Page Section',
      'lp_section': this.sceneName,
      'lp_loc': '1R'
    })
    if (this.scrollEnabled) {
      this.modalTimeout = setTimeout(this.enableModal, 3000)
    }
  },

  methods: {
    enableModal () {
      this.setMapModal(true)
    },
    setMapModal (state) {
      clearTimeout(this.modalTimeout)
      this.mapModal = state
    },
    setActiveMap (location) {
      clearTimeout(this.modalTimeout)
      this.activeLocation = location
      this.setMapModal(false)
      this.modalTimeout = setTimeout(this.enableModal, 1000)
      if (this.activeLocation) {
        this.$gtm.trackEvent({
          'event': 'Click Map Name',
          'lp_mapName': this.activeLocation.Title
        })
      } else {
        this.$gtm.trackEvent({
          'event': 'Close Map'
        })
      }
    },
    clickVillage () {
      this.$gtm.trackEvent({
        'event': 'Back from Map'
      })
      this.$store.dispatch('setScene', 'village')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/mixins.scss';

.content--top {
  padding-top: 70px;

  @include breakpoint(sm) {
    padding-top: 100px;
  }
}
.title {
  display: none;

  @include breakpointHeight(md) {
    display: block;
  }

  @include breakpoint(md) {
    display: none;

    @include breakpointHeight(700px) {
      display: block;
    }
  }
}
.worldmap {
  position: absolute;
  z-index: 2;
  top: 50px;
  left: 50%;
  width: 905px;
  max-width: 60%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  transform: translateX(-50%);

  @include breakpointHeight(md) {
    top: 180px;
    max-width: 100%;
  }

  @include breakpoint(md) {
    top: auto;
    bottom: 95px;
    max-width: 80%;
  }

  @include breakpoint(lg) {
    max-width: 600px;

    @include breakpointHeight(850px) {
      max-width: 800px;
    }
    @include breakpointHeight(920px) {
      max-width: 100%;
    }
  }
}
.worldmap__inner {
  position: absolute;
  z-index: 0;
  top: 0;
  left: 0;
  width: 100%;
  padding-bottom: 65%;

  @include breakpointHeight(md) {
    padding-bottom: 72%;
  }

  @include breakpoint(md) {
    top: auto;
    bottom: 0;
  }
}
.frame-wood {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 105%;
  pointer-events: none;
  object-fit: cover;
}
.frame {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  display: none;
  pointer-events: none;

  @include breakpoint(md) {
    display: block;
  }

  &--topleft,
  &--topright {
    z-index: 3;
    top: 0;
    width: 66px;
  }
  &--topleft {
    left: 1px;
    right: auto;
  }
  &--topright {
    left: auto;
    right: 1px;
  }
  &--top {
    top: 19px;
    left: 32px;
    right: 32px;
    height: 15px;
    background-image: url('../../../assets/images/world/frame-top.png');
    background-position: center;
    background-size: auto 100%;
    background-repeat: repeat-x;
  }
  &--right,
  &--left {
    top: 32px;
    bottom: -3px;
    width: 15px;
    background-image: url('../../../assets/images/world/frame-post.png');
    background-position: center;
    background-size: 100%;
    background-repeat: repeat-y;
  }
  &--left {
    left: 21px;
    right: auto;
  }
  &--right {
    left: auto;
    right: 22px;
  }
}
.frame-wood {
  display: block;

  @include breakpoint(md) {
    display: none;
  }
}
.worldmap__map {
  position: absolute;
  z-index: 1;
  top: 11%;
  left: 4%;
  right: 4%;
  bottom: -3%;

  @include breakpoint(md) {
    top: 4%;
    bottom: 1%;
  }
}
.map__canvas {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.worldmap__close {
  position: absolute;
  z-index: 1;
  top: 30px;
  left: 30px;
  cursor: pointer;
  opacity: 1;
  transition: opacity .5s ease;

  &:hover {
    opacity: .6;
  }
}

.location {
  position: absolute;
  z-index: 1;
  cursor: pointer;
  transform: translate3d(-50%, -50%, 0);

  &:hover {
    .location__tag {
      transform: scale(1.1);
    }
  }
}
.location__tag {
  height: 25px;
  transform: scale(1);
  transition: transform .5s ease;

  @include breakpoint(400px) {
    height: 30px;
  }
  @include breakpoint(sm) {
    height: 41px;
  }
}

.modal {
  position: absolute;
  z-index: 6;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  @include breakpoint(md) {
    top: auto;
    bottom: 120px;
    left: 60%;
    right: auto;
    align-items: flex-end;
  }
}
.underlay--modal {
  background-color: $black;
  opacity: .6;

  @include breakpoint(md) {
    display: none;
  }
}
.scroll__close {
  top: -5px;
  right: -20px;
}
.scroll__background {
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
  max-width: 480px;
}
</style>
